import { render } from "./AddNewModal.vue?vue&type=template&id=4c5b652c&scoped=true&ts=true"
import script from "./AddNewModal.vue?vue&type=script&lang=ts"
export * from "./AddNewModal.vue?vue&type=script&lang=ts"

import "./AddNewModal.vue?vue&type=style&index=0&id=4c5b652c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c5b652c"]])

export default __exports__